import OnboardingNotifySvg from '@/../assets/illustrations/onboarding-notify.svg';
import OnboardingNotifyJaSvg from '@/../assets/illustrations/onboarding-notify.ja.svg';
import { useTranslation } from '@/i18n';

const SVG_NATURAL_WIDTH = 412;
const SVG_NATURAL_HEIGHT = 407;

interface IllustrationProps {
  readonly width: number;
  readonly height: number;
}

export const OnboardingNotifyIllustration = ({ width, height }: IllustrationProps) => {
  const { locale } = useTranslation();
  const Svg = locale === 'ja' ? OnboardingNotifyJaSvg : OnboardingNotifySvg;
  const scale = Math.min(width / SVG_NATURAL_WIDTH, height / SVG_NATURAL_HEIGHT);
  return (
    <Svg
      height={SVG_NATURAL_HEIGHT * scale}
      testID="onboarding-notify-illustration"
      width={SVG_NATURAL_WIDTH * scale}
    />
  );
};
